export const faqs = [
  {
    question: "Combien de temps faut-il pour réparer un volet roulant ?",
    answer: "Dans la plupart des cas, la réparation se fait en une seule intervention, le jour même ou le lendemain de votre appel. Pour les pannes simples — sangle cassée, cordon usé, réglage moteur — le technicien termine en moins d'une heure. Si une pièce spécifique doit être commandée, nous revenons dans les 24 à 48h.",
  },
  {
    question: "Faut-il forcément remplacer tout le volet ?",
    answer: "Non, absolument pas. Dans environ 90 % des cas, seule une pièce est défectueuse : le moteur, la sangle, une lame de tablier ou la télécommande. Nous remplaçons uniquement la pièce concernée, ce qui vous évite le coût d'une installation complète. Notre diagnostic gratuit vous permet de connaître la solution exacte avant tout engagement.",
  },
  {
    question: "Intervenez-vous en urgence à Strasbourg ?",
    answer: "Oui, nous proposons un service d'urgence 24h/24 et 7j/7 pour tout volet bloqué en position ouverte ou fermée, notamment en cas de départ en vacances ou de problème de sécurité. Pour les urgences, appelez-nous directement au 03 74 47 32 40 et nous vous donnons un créneau d'intervention rapide.",
  },
  {
    question: "Quelles marques de volets roulants réparez-vous ?",
    answer: "Nous réparons toutes les marques sans exception : Somfy, Nice, Simu, Bubendorff, Profalux, Elero, ainsi que les volets sans marque ou de constructeurs de maisons individuelles. Nos techniciens connaissent les spécificités de chaque motorisation et disposent des pièces compatibles les plus courantes en stock.",
  },
];

export default function FAQ() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-10 md:mb-14">
          Questions fréquentes sur la réparation de volet roulant
        </h2>
        <div className="space-y-6">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-brand-light rounded-xl border border-brand-border p-6 md:p-8">
              <h3 className="text-brand-blue text-base font-bold mb-3">{faq.question}</h3>
              <p className="text-brand-text text-sm leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}